var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classModifiers},[_c('div',{class:_vm.iconClassModifiers}),_vm._v(" "),_c('div',{staticClass:"market-disabled-outcome-v2__text"},[_vm._v("\n      "+_vm._s(_vm.buttonText)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4536ead8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/market/v2/market-disabled-outcome-v2/market-disabled-outcome-v2.vue
// module id = ikte
// module chunks = 65